import React from 'react';
import ErrorMessage from '../../../Elements/ErrorMessage';

function ToastDemoComponent() {
  return (
    <div className='dsg-row'>
      <button
        type='button'
        className='btn'
        onClick={() =>
          ErrorMessage.SetErrorMessage(
            'Something went wrong while getting OpenAi Chat Sessions. Response status code does not indicate success: 404 (Not Found).'
          )
        }
      >
        <i className='fa-solid fa-triangle-exclamation' /> Fire error toast (sticky)
      </button>
      <button
        type='button'
        className='btn'
        onClick={() => ErrorMessage.SetNotification('Payment applied.')}
      >
        <i className='fa-solid fa-circle-info' /> Fire notification (4s)
      </button>
      <button
        type='button'
        className='btn'
        onClick={() => ErrorMessage.SetSuccessMessage('Copied to clipboard')}
      >
        <i className='fa-solid fa-circle-check' /> Fire success toast (4s)
      </button>
    </div>
  );
}

export const toastDemo = {
  id: 'toasts',
  title: 'Toasts',
  category: 'Overlays & Editing',
  importPath: 'Elements/ErrorMessage (SetErrorMessage / SetNotification / SetSuccessMessage)',
  notes: [
    'Fired from anywhere via the app-wide ErrorMessage host (mounted once in app.js). Renders a top-right stack of DS toast cards.',
    'Errors are sticky (close with the X); notification + success auto-dismiss after ~4 seconds. Identical messages dedup.',
    'SetSuccessMessage is the transient green toast (mirrors SetErrorMessage); SetSuccess is a separate modal popup and is unchanged.',
  ],
  snippet:
    "ErrorMessage.SetErrorMessage('Could not load sessions'); // sticky\nErrorMessage.SetNotification('Payment applied.'); // 4s\nErrorMessage.SetSuccessMessage('Copied to clipboard'); // 4s",
  render: ToastDemoComponent,
};
